const NATIVE_LEVEL = 5;

function normalize(text) {
  return String(text || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

function matches(language, query) {
  if (query === '') return true;
  return normalize(language.language).includes(query) || normalize(language.native).includes(query);
}

// Learning languages first (that's what people practice), then native ones.
function orderedUserLanguages(userLanguages) {
  const rows = Array.isArray(userLanguages) ? userLanguages : [];
  return [
    ...rows.filter(row => row.level < NATIVE_LEVEL),
    ...rows.filter(row => row.level >= NATIVE_LEVEL),
  ];
}

export function languageId(language) {
  if (!language) return undefined;
  return language.language_id !== undefined ? language.language_id : language.id;
}

export function defaultGameLanguage(languages, userLanguages) {
  const all = Array.isArray(languages) ? languages : [];
  for (const row of orderedUserLanguages(userLanguages)) {
    const match = all.find(language => language.id === row.language_id);
    if (match) return match;
  }
  return all[0];
}

export function groupLanguages(languages, userLanguages, search) {
  const all = Array.isArray(languages) ? languages : [];
  const query = normalize(search);
  const mine = [];
  const mineIds = new Set();

  orderedUserLanguages(userLanguages).forEach(row => {
    const language = all.find(l => l.id === row.language_id);
    if (!language || mineIds.has(language.id)) return;
    mineIds.add(language.id);
    if (matches(language, query)) {
      mine.push({ language, tag: row.level >= NATIVE_LEVEL ? 'Native' : 'Learning' });
    }
  });

  const others = all
    .filter(language => !mineIds.has(language.id) && matches(language, query))
    .sort((a, b) => String(a.language).localeCompare(String(b.language)))
    .map(language => ({ language, tag: null }));

  return { mine, others };
}
